<template>
  <div>
    <img :src="require('../../images/howto/cachchoipower.png')">
  </div>
</template>

<style lang="scss" scoped>
img {
  width: 100vw;
}
</style>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'PowerHelp'
  })
</script>
